import React from "react";
import ProjectWorkflowContainer from "../containers/project/ProjectWorkflowContainer/ProjectWorkflowContainer";
import BlankLayout from "../layouts/BlankLayout";

function ProjectView() {
  return (
    <BlankLayout>
      <ProjectWorkflowContainer />
    </BlankLayout>
  );
}

export default ProjectView;
